export function isEmptyValue(val: any): boolean {
  const isEmpty =
    val === '' ||
    val === null ||
    typeof val === 'undefined' ||
    (Array.isArray(val) && val?.length === 0);
  return isEmpty;
}
